import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useApp } from './use-app';
import { Record } from '../editor/record.types';

export default function useRecord(recordId: string): UseQueryResult<Record<object>, unknown> {
  const app = useApp();

  const loadRecord = () => {
    const { api } = app;
    // @ts-ignore
    return api.records.find(recordId);
  };

  return useQuery(['record', recordId], loadRecord, { refetchOnWindowFocus: false });
}
